import {insertScript} from '@optimaxdev/utils';

import {FUNCTIONAL_COOKIES} from 'constants/analytics';
import {REVIEWS_POPUPS_SRC} from 'constants/popupNames';
import {waitForActivatingCookieGroup} from 'features/oneTrust/oneTrust';
import {ReviewPopupsType} from 'types/reviewPopupsTypes';

/**
 * Prepare data to set into window
 */
function setWindowData(orderDetails: ReviewPopupsType) {
    const {id, shipping_address: shippingAddress} = orderDetails;
    // eslint-disable-next-line no-underscore-dangle
    window._rrES = {
        auto: true,
        email: shippingAddress.email,
        invoice: id,
        seller_id: 29692,
    };
}

/**
 * Reseller initialization at TYP
 */
export async function initReseller(
    orderDetails: ReviewPopupsType,
    setIsPopupLoading?: (isLoading: boolean) => void,
) {
    await waitForActivatingCookieGroup(FUNCTIONAL_COOKIES);
    setWindowData(orderDetails);
    if (setIsPopupLoading) setIsPopupLoading(true);
    insertScript(
        REVIEWS_POPUPS_SRC.RESELLER,
        true,
        () => setIsPopupLoading && setIsPopupLoading(false),
    );
}
